export const LIVE_REGION_UPDATE_TIMEOUT = 1000;
export const LIVE_REGION_CLEAR_TIMEOUT = 250;